var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(['User'].includes(_vm.profile.role))?_c('UserHome',{attrs:{"profile":_vm.profile,"notifications":_vm.notifications}}):(['Corrector', 'Animator', 'Admin', 'SuperAdmin'].includes(_vm.profile.role))?_c('AdminHome',{attrs:{"profile":_vm.profile}}):_c('NoneHome',{attrs:{"profile":_vm.profile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }